import {
  createApiFactory,
  createComponentExtension,
  createPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { syntaxHighlighterApiRef } from './api';
import {
  createTechDocsAddonExtension,
  TechDocsAddonLocations,
} from '@backstage/plugin-techdocs-react';
import { TechDocsCodeSnippetsAddon } from './components/TechDocsCodeSnippets';
import { SyntaxHighlighterClient } from '@appfolio/backstage-plugin-syntax-highlighter-common';

export const syntaxHighlighterPlugin = createPlugin({
  id: 'appfolio-syntax-highlighter',
  apis: [
    createApiFactory({
      api: syntaxHighlighterApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new SyntaxHighlighterClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const CodeSnippet = syntaxHighlighterPlugin.provide(
  createComponentExtension({
    name: 'CodeSnippet',
    component: {
      lazy: () => import('./components/CodeSnippet').then(m => m.CodeSnippet),
    },
  }),
);

export const TechDocsCodeSnippets = syntaxHighlighterPlugin.provide(
  createTechDocsAddonExtension({
    name: 'TechDocsCodeSnippets',
    location: TechDocsAddonLocations.Content,
    component: TechDocsCodeSnippetsAddon,
  }),
);
